import { relations } from 'drizzle-orm'
import { pgTable, primaryKey, text, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'
import z from 'zod/v4'

import { organization } from '../../auth'
import { Voucher } from './voucher'

export const VoucherToOrganization = pgTable(
  'voucher_to_organization',
  {
    voucherId: uuid()
      .notNull()
      .references(() => Voucher.id, { onDelete: 'cascade' }),
    organizationId: text()
      .notNull()
      .references(() => organization.id, { onDelete: 'cascade' }),
  },
  (t) => [primaryKey({ columns: [t.voucherId, t.organizationId] })],
)

export const voucherToOrganizationRelations = relations(VoucherToOrganization, ({ one }) => ({
  voucher: one(Voucher, {
    fields: [VoucherToOrganization.voucherId],
    references: [Voucher.id],
  }),

  organization: one(organization, {
    fields: [VoucherToOrganization.organizationId],
    references: [organization.id],
  }),
}))

export const InsertVoucherToOrganizationSchema = createInsertSchema(VoucherToOrganization, {
  voucherId: z.uuid(),
  organizationId: z.string(),
})

export const UpdateVoucherToOrganizationSchema = createUpdateSchema(VoucherToOrganization, {})
  .omit({
    voucherId: true,
    organizationId: true,
  })
  .partial()

export const SelectVoucherToOrganizationSchema = createSelectSchema(VoucherToOrganization, {
  voucherId: z.uuid(),
  organizationId: z.string(),
})

export type InsertVoucherToOrganization = typeof VoucherToOrganization.$inferInsert
export type UpdateVoucherToOrganization = z.infer<typeof UpdateVoucherToOrganizationSchema>
export type SelectVoucherToOrganization = typeof VoucherToOrganization.$inferSelect
